import { render, staticRenderFns } from "./BaggerForm.vue?vue&type=template&id=8bab19e4&"
import script from "./BaggerForm.vue?vue&type=script&lang=js&"
export * from "./BaggerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports